import {BlogNav} from 'modules/blog/components/BlogNav';
import {ReactNode} from 'react';
import style from './style.module.scss';
import {IArticleType} from 'modules/blog/models';
import {PageHead} from 'core/modules/PageHead';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';
import {IBreadcrumb} from 'modules/seo/types';
import {TrustSlider} from 'modules/slider/components/TrustSlider';
import {Box, Col, Row} from 'components/Grid';
import Head from 'next/head';

interface IBlogLayoutPageProps {
    articleTypes?: IArticleType[];
    children?: ReactNode;
    title?: string;
    robots?: string;
    description?: string;
    breadcrumbs?: IBreadcrumb[];
    articleSchemaJson?: Record<string, any> | undefined;
    imageUrl?: string;
}

export const BlogLayoutPage = ({
    children,
    articleTypes,
    title,
    robots,
    description,
    breadcrumbs = [],
    articleSchemaJson,
    imageUrl,
}: IBlogLayoutPageProps) => {
    return (
        <>
            <PageHead description={description} robots={robots} title={title} imageUrl={imageUrl} />
            {articleSchemaJson && (
                <Head>
                    <script
                        type={'application/ld+json'}
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(articleSchemaJson),
                        }}
                    />
                </Head>
            )}
            {0 < breadcrumbs.length && (
                <Box>
                    <Row>
                        <Col sm={12}>
                            <Breadcrumbs breadcrumbs={breadcrumbs} />
                        </Col>
                    </Row>
                </Box>
            )}
            <div className={style.blogNavWrap}>
                <BlogNav articleTypes={articleTypes} />
            </div>
            {children}
            <TrustSlider />
        </>
    );
};
